import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormNavigationConfig, DefaultFormConfig, FormPageComponentClass } from '@ptl/forms';
import { ReducerUtilityService } from '@ptl/state';

@FormComponentLookup('review-effective-date-attesation')
@Component({
    selector: 'app-review-effective-date-attesation',
    templateUrl: './review-effective-date-attesation.component.html',
    styleUrls: ['./review-effective-date-attesation.component.scss'],
    standalone: false
})

export class ReviewEffectiveDateAttestationComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit {

  effectiveDate: any;
  selectedElectionPeriodEvent: any;


  constructor(
    protected reducerUtilityService: ReducerUtilityService
  ) {
    super();
  }

  ngOnInit(): void {
    this.selectedElectionPeriodEvent = this.reducerUtilityService.getPayloadStates()?.ElectionPeriod?.selectedElectionPeriodEvent;
  }

  editQuestion() {
    this.emitCustomPage(4);
  }

}

